<style scoped lang="scss">
@import '../../scss/login.scss';
.login-template{
  background:url('../../img/jnj-login-bg.jpg') no-repeat center top;
  background-size:cover
}

.login-wrap{
    position: absolute;
    top: 130px;
    left: 200px;
    margin-left: 0;
    .default-btn{
      background:#b52323
    }
    .logo-row{
      background:none;
    .logo-txt{
      display:flex;
      flex-direction: column;
      text-align:center;
    }
    strong{
      color:#b52323;
      font-size:45px;
      line-height:1;
      margin-bottom:10px;
    }
    span{
      color:#b52323;
    }
  }
}
.login-hr{
    height: 2px;
    overflow: hidden;
    width: 100%;
    background: #b52323;
    bottom: 150px;
    position: absolute;
}
.left-column{
  width:calc(100% - 200px);
  left:100px;  
  margin-left:0;
  .copyright{
    bottom:50px;
    right:100px;
    background: #cbc9c9c7;
    border-radius: 10px;
    padding:0 10px;
  }
  svg{
    position:absolute;
    right:100px;
    bottom:150px;
  }
}
.person-info-modal{
  .v-dialog{
    .v-card__text{
      padding:0 24px;
    }
    .v-card__title{
      &.inform{
        padding-top:0;
      }
    }
    .desc-wrap{
      justify-content: start;
      padding:20px;
      height:150px;
    }
    .btns{
      padding-bottom:20px;
    }
  }
}

@media (max-width: 1600px) {
  .login-wrap{
    top:100px;
    .logo-row{
      background:#b52323;
    strong{
      color:#fff;
      font-size:45px;
      line-height:1;
      margin-bottom:10px;
    }
    span{
      color:#fff;
    }
  }
  }
  
  .left-column{
    svg{
      bottom:100px;
    }
    .login-hr{
      bottom:100px;
    }
    .copyright{
      bottom:20px
    }
  }
  .logo-row{
    .logo-txt{
      display:flex;
      flex-direction: column;
      text-align:center;
    }
    
  }
}

@media (max-width: 1200px) {
  .login-wrap {
    .logo-row{
      background:none;
      strong{
        color:#b52323;
      }
      span{
        color:#b52323;
      }
    }
  }
}
@media (min-width: 1600px) {
  .login-wrap {
    .logo-row{
      background:#b52323;
      strong{
        color:#fff;
      }
      span{
        color:#fff;
      }
    }
  }
}
</style>
<template>
  <div class="login-template">
    <div class="left-column" data-hidden="mobile">
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        id="svg17847"
        version="1.1"
        viewBox="0 0 1000 181.354"
        height="100"
        width="250"
        inkscape:version="0.91 r13725"
        sodipodi:docname="Johnson and Johnson 2.svg">
        <sodipodi:namedview
          pagecolor="#ffffff"
          bordercolor="#ffffff"
          borderopacity="1"
          objecttolerance="10"
          gridtolerance="10"
          guidetolerance="10"
          inkscape:pageopacity="0"
          inkscape:pageshadow="2"
          inkscape:window-width="1366"
          inkscape:window-height="705"
          id="namedview5870"
          showgrid="false"
          inkscape:zoom="0.5"
          inkscape:cx="372.61592"
          inkscape:cy="106.54354"
          inkscape:window-x="-8"
          inkscape:window-y="-8"
          inkscape:window-maximized="1"
          inkscape:current-layer="svg17847" />
        <defs
          id="defs17841" />
        <metadata
          id="metadata17844">
          <rdf:RDF>
            <cc:Work
              rdf:about="">
              <dc:format>image/svg+xml</dc:format>
              <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
              <dc:title></dc:title>
            </cc:Work>
          </rdf:RDF>
        </metadata>
        <g
          transform="matrix(2.5252523,0,0,2.5252523,-946.16986,-1244.8008)"
          id="layer1">
          <g
            style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:1"
            id="--Symbols"
            transform="matrix(3.3220133,0,0,3.3220133,374.68251,490.3022)">
            <g
              style="fill:#ffffff;fill-opacity:1"
              transform="translate(-137,-447)"
              id="Footer-1440">
              <g
                style="fill:#ffffff;fill-opacity:1"
                transform="translate(137,447)"
                id="Logo">
                <path
                  style="fill:#ffffff;fill-opacity:1"
                  id="Fill-1"
                  d="m 43.252689,8.6221987 c 0,-0.1962914 0.13351,-0.3011921 0.301192,-0.3011921 0.283708,0 0.712053,0.3011921 0.953642,0.9035762 -0.08662,0 -0.216953,0.026225 -0.304371,0.026225 -0.516556,0 -0.950463,-0.245563 -0.950463,-0.6286093 z m -31.252451,0 c 0,-0.1962914 0.127947,-0.3011921 0.302782,-0.3011921 0.276556,0 0.687417,0.3011921 0.925828,0.9035762 -0.797881,0 -1.22861,-0.1724503 -1.22861,-0.6023841 z M 18.028053,5.509351 c 0,-3.2225166 0.627814,-3.7176159 0.822516,-3.7176159 0.346491,0 0.387815,0.2161589 0.387815,1.4519205 0,1.2699338 -0.541192,2.9316557 -1.210331,3.8439735 z M 39.97057,8.6865695 c -0.371921,0.5181457 -0.673113,1.2540398 -0.673113,2.2021195 0,1.815894 1.035497,3.549139 3.047682,3.549139 1.945431,0 3.308344,-1.536954 3.308344,-3.680265 0,-0.622252 -0.02384,-0.70808 -0.06437,-0.9663577 0.452185,-0.1970861 0.842384,-0.4982781 1.14596,-0.7390728 0.258278,-0.194702 0.451391,-0.3035762 0.605563,-0.3035762 0.193907,0 0.27894,0.1517881 0.27894,0.4323179 l 0,4.2405298 c 0,0.690596 0.218543,1.016424 0.756557,1.016424 0.495894,0 0.844768,-0.34808 1.03788,-0.758146 0.715232,-1.491655 1.750729,-3.48 2.202914,-4.2349668 0.108874,-0.173245 0.197086,-0.3059602 0.259073,-0.3059602 0.08662,0 0.131126,0.06596 0.131126,0.3456953 l 0,3.3758937 c 0,0.949669 0.433907,1.577484 1.381192,1.577484 0.996556,0 1.490861,-0.954437 2.361854,-2.423841 0.04133,-0.08821 0.0596,-0.150994 0.0596,-0.213775 0,-0.194702 -0.168477,-0.305166 -0.342517,-0.305166 -0.196291,0 -0.304371,0.196292 -0.951258,0.90755 -0.131126,0.135099 -0.258278,0.322649 -0.498278,0.322649 -0.08583,0 -0.151788,-0.104106 -0.151788,-0.236026 l 0,-3.7843713 c 0,-1.0164239 -0.45457,-1.4264901 -1.037881,-1.4264901 -0.474437,0 -0.865431,0.194702 -1.275497,0.8002649 -0.735099,1.0831788 -1.491655,2.6193375 -1.900927,3.3933775 -0.04609,0.0906 -0.108079,0.219338 -0.150199,0.219338 -0.0453,0 -0.06437,-0.06676 -0.06437,-0.219338 l 0,-2.7671523 c 0,-0.7978808 -0.216159,-1.4264901 -1.060928,-1.4264901 -0.886887,0 -1.339867,0.6063576 -1.988344,1.0593378 -0.410861,0.3059602 -0.777219,0.5197351 -1.056954,0.6492715 -0.434702,-1.1022517 -1.233377,-1.6609272 -1.903311,-1.6442384 -0.672318,0.023046 -1.14755,0.4362914 -1.14755,1.1284768 0,0.7096689 0.434702,1.2039735 1.01563,1.424106 0.322649,0.1295367 0.626225,0.1541717 1.060927,0.1541717 0.130331,0 0.259073,0 0.342516,-0.02463 0.04609,0.215364 0.02543,0.522119 0.02543,0.75894 0,1.060927 -0.62702,2.117086 -1.792848,2.117086 -1.21351,0 -1.923973,-1.167417 -1.923973,-2.50649 0,-1.0172184 0.301192,-1.8588078 0.794702,-2.4405297 0.19947,-0.2177483 0.348079,-0.3496689 0.348079,-0.5491391 0,-0.1009271 -0.148609,-0.1263576 -0.279735,-0.1263576 -0.823311,0 -1.728477,0.3687417 -2.353907,0.6913907 -0.825696,0.4331126 -1.796027,1.1491391 -2.597086,1.8619868 -0.38861,-0.8670199 -0.863842,-1.6235762 -1.103047,-2.2092715 -0.08583,-0.2376159 -0.148609,-0.5133775 -0.321854,-0.5133775 -0.153377,0 -0.220133,0.1509934 -0.325828,0.4490066 -0.387814,1.146755 -2.464371,4.5003973 -2.918146,4.9541723 -0.04291,0.06199 -0.105695,0.130331 -0.126357,0.130331 -0.04689,0 -0.07152,-0.02146 -0.07152,-0.153377 l 0,-3.7843713 c 0,-1.0164239 -0.410067,-1.4264901 -0.967947,-1.4264901 -0.477616,0 -0.886888,0.194702 -1.275497,0.8002649 -0.712053,1.0831788 -1.580662,2.6614575 -1.989934,3.4378805 -0.06596,0.13351 -0.131126,0.174835 -0.153377,0.174835 -0.02146,0 -0.03894,-0.08583 -0.03894,-0.219338 l 0,-2.7671523 c 0,-1.0164239 -0.41245,-1.4264901 -0.975099,-1.4264901 -0.476821,0 -0.928212,0.1772186 -1.297748,0.8002649 -0.905961,1.5369537 -2.418279,3.8932455 -2.699603,4.2794705 -0.04371,0.06676 -0.08742,0.110463 -0.130331,0.131126 -0.04291,0 -0.06755,-0.04212 -0.06755,-0.149404 l 0,-3.6349673 c 0,-1.0164239 -0.410066,-1.4264901 -0.968742,-1.4264901 -0.779602,0 -1.209536,0.7168212 -1.493245,1.1682119 -0.390993,0.6270199 -0.907549,1.4717881 -1.316821,2.2513905 -0.282119,0.521325 -0.521324,0.993378 -0.608742,0.993378 -0.04132,0 -0.04132,-0.196292 -0.04132,-0.562649 l 0,-2.8958943 c 1.359735,-1.5162914 2.203709,-3.3735099 2.203709,-5.4055629 0,-1.1698013 -0.516557,-1.8150994 -1.314438,-1.8150994 -1.494834,0 -2.637615,2.3356292 -2.637615,5.1003974 l 0,2.2482119 C 15.586733,8.7938593 14.937461,9.00525 14.136401,9.1618063 13.72713,7.9538593 12.860905,7.3260447 12.171898,7.3427335 c -0.668344,0.023046 -1.14596,0.4362914 -1.14596,1.1284768 0,1.1443709 1.124503,1.6196027 2.116291,1.6196027 l 0.281325,0 c 0.04212,0.217748 0.04212,0.456159 0.04212,0.69298 0,1.060927 -0.626225,2.117086 -1.790464,2.117086 -1.209536,0 -1.9247679,-1.167417 -1.9247679,-2.50649 0,-1.0172184 0.2996029,-1.8588078 0.7970859,-2.4405297 0.196292,-0.2177483 0.348874,-0.4124503 0.348874,-0.5491391 0,-0.1009271 -0.152582,-0.1263576 -0.283708,-0.1263576 -0.8209274,0 -2.6344373,1.1070199 -4.7976161,3.2686094 C 5.6235497,8.8169007 5.4058013,7.1289536 5.4058013,5.4855099 c 0,-1.8365563 0.3631788,-3.3965563 0.4498013,-3.8463576 0.043709,-0.2789404 0.070728,-0.4545695 0.070728,-0.5817218 0,-0.17403977 -0.092185,-0.26304639 -0.3250331,-0.26304639 -1.7531126,0 -5.6010595894,2.79019869 -5.6010595894,6.96238409 0,2.9586758 1.0831787894,4.3867548 2.9602648894,6.2241058 -1.1396026,1.838146 -2.05350992,4.020398 -2.05350992,5.966623 0,1.402649 0.32741722,2.465165 1.36211922,2.465165 2.1623841,0 3.7819867,-4.494039 3.7819867,-7.82543 0,-0.993378 -0.039735,-1.989139 -0.1247682,-2.981722 C 6.7234172,10.757563 7.956,9.6155762 8.2563974,9.5074967 8.1276556,9.9620662 8.0410331,10.438887 8.0410331,10.888689 c 0,1.815894 1.0394702,3.549139 3.0476819,3.549139 1.883444,0 3.30755,-1.536954 3.30755,-3.680265 0,-0.276556 -0.02225,-0.517351 -0.04133,-0.7756292 0.688212,-0.1295365 1.32159,-0.306755 1.924769,-0.6683444 l 0,4.3446356 c 0,0.55947 0.386225,0.779603 0.754172,0.779603 0.499867,0 0.75894,-0.34808 1.122914,-1.143576 0.30596,-0.651656 1.124503,-2.141722 1.621192,-3.030994 0.391788,-0.6937746 0.607947,-1.1443706 0.781987,-1.1443706 0.04053,0 0.08662,0.1056954 0.08662,0.3655629 l 0,3.6977487 c 0,0.994967 0.51894,1.255629 0.967947,1.255629 0.432318,0 0.715232,-0.237616 0.996556,-0.627815 1.125298,-1.601324 2.315762,-3.501457 2.787815,-4.3255627 0.08742,-0.1478145 0.194702,-0.2598675 0.282119,-0.2598675 0.08424,0 0.127947,0.046887 0.127947,0.3242384 l 0,3.8725828 c 0,0.690596 0.216159,1.016424 0.75894,1.016424 0.494305,0 0.817749,-0.34808 1.010861,-0.758146 0.718411,-1.491655 1.77457,-3.460132 2.230729,-4.2349668 0.105695,-0.173245 0.214569,-0.3258278 0.27894,-0.3258278 0.0898,0 0.109669,0.1056954 0.109669,0.3886093 l 0,3.6747023 c 0,0.994967 0.518941,1.255629 0.975894,1.255629 0.6,0 0.993378,-0.434702 1.381987,-0.929801 0.708874,-0.933775 1.74755,-2.591524 2.375364,-3.6556296 0.217749,0.3472846 0.45298,0.7589406 0.650861,1.2119206 -0.519735,0.62702 -1.03947,1.338278 -1.03947,2.09404 0,0.801059 0.561854,1.27947 1.14596,1.27947 0.992583,0 1.899338,-0.954437 1.899338,-2.270464 0,-0.517351 -0.148609,-1.059337 -0.341722,-1.576688 0.881325,-0.8670204 1.942252,-1.7101992 2.724238,-1.9041065 z M 4.3647417,13.399152 c 0.1748345,1.144371 0.3266225,2.271259 0.3266225,3.155762 0,2.071788 -0.6898013,4.49404 -1.8794702,4.474172 -0.4593377,0 -0.8455629,-0.459338 -0.8646357,-1.254834 -0.043709,-2.591524 1.1880794,-4.797616 2.4174834,-6.3751 z M 35.924742,11.925775 c 0.131125,0.37192 0.197086,0.672318 0.197086,0.975099 0,0.34649 -0.130331,0.69298 -0.369537,0.69298 -0.170066,0 -0.343311,-0.194702 -0.343311,-0.498278 0,-0.325033 0.279735,-0.843973 0.515762,-1.169801 z M 5.1451391,1.616106 c 0,0.1319205 -0.3027815,0.7350993 -0.6905961,1.8174834 -0.4108609,1.1221192 -0.802649,2.7202649 -0.802649,4.6450331 0,1.1459603 0.2837087,2.6614575 0.5229139,4.1952315 l -0.6921854,0.93298 C 2.3787815,11.862993 1.6881854,10.352265 1.6881854,7.7567682 c 0,-3.6739073 2.2259603,-6.2225165 3.3695364,-6.2225165 0.068344,0 0.087417,0.019073 0.087417,0.081854 z"
                  inkscape:connector-curvature="0" />
                <path
                  style="fill:#ffffff;fill-opacity:1"
                  id="Fill-4"
                  d="m 106.64956,8.6221987 c 0,-0.1962914 0.12636,-0.3011921 0.3012,-0.3011921 0.27894,0 0.71205,0.3011921 0.94887,0.9035762 -0.0842,0 -0.21378,0.026225 -0.30437,0.026225 -0.51417,0 -0.9457,-0.245563 -0.9457,-0.6286093 z m -31.258805,0 c 0,-0.1962914 0.131921,-0.3011921 0.302781,-0.3011921 0.281325,0 0.696159,0.3011921 0.929007,0.9035762 -0.79947,0 -1.231788,-0.1724503 -1.231788,-0.6023841 z M 81.422543,5.509351 c 0,-3.2225166 0.623841,-3.7176159 0.820927,-3.7176159 0.344901,0 0.38861,0.2161589 0.38861,1.4519205 0,1.2699338 -0.541987,2.9316557 -1.209537,3.8439735 z m -13.659338,7.889801 c 0.167682,1.144371 0.325033,2.271259 0.325033,3.155762 0,2.071788 -0.690596,4.49404 -1.882649,4.474172 -0.45298,0 -0.842384,-0.459338 -0.863841,-1.254834 -0.0445,-2.591524 1.189669,-4.797616 2.421457,-6.3751 z m 31.559206,-1.473377 c 0.131125,0.37192 0.193112,0.672318 0.193112,0.975099 0,0.34649 -0.129536,0.69298 -0.367152,0.69298 -0.170861,0 -0.348874,-0.194702 -0.348874,-0.498278 0,-0.325033 0.283708,-0.843973 0.522914,-1.169801 z M 68.537245,1.616106 c 0,0.1319205 -0.299603,0.7350993 -0.691391,1.8174834 -0.407682,1.1221192 -0.79947,2.7202649 -0.79947,4.6450331 0,1.1459603 0.288477,2.6614575 0.524503,4.1952315 l -0.693774,0.93298 c -1.100663,-1.343841 -1.796027,-2.854569 -1.796027,-5.4500658 0,-3.6739073 2.230729,-6.2225165 3.374305,-6.2225165 0.06278,0 0.08185,0.019073 0.08185,0.081854 z m -3.603973,10.808742 c 0.386225,0.51894 0.863046,1.015629 1.4249,1.556026 -1.146755,1.838146 -2.05351,4.020398 -2.05351,5.966623 0,1.402649 0.326623,2.465165 1.364504,2.465165 2.159205,0 3.778808,-4.494039 3.778808,-7.82543 0,-0.993378 -0.04212,-1.989139 -0.128742,-2.981722 0.801059,-0.847947 2.028874,-1.9899338 2.335629,-2.0980133 -0.130331,0.4545695 -0.220132,0.9313903 -0.220132,1.3811923 0,1.815894 1.038675,3.549139 3.05086,3.549139 1.878676,0 3.305166,-1.536954 3.305166,-3.680265 0,-0.276556 -0.01987,-0.517351 -0.04371,-0.7756292 0.692981,-0.1295365 1.323974,-0.306755 1.925563,-0.6683444 l 0,4.3446356 c 0,0.55947 0.38702,0.779603 0.751788,0.779603 0.503841,0 0.762914,-0.34808 1.128477,-1.143576 0.301192,-0.651656 1.124504,-2.141722 1.622782,-3.030994 0.387814,-0.6937746 0.603973,-1.1443706 0.781192,-1.1443706 0.04053,0 0.08106,0.1056954 0.08106,0.3655629 l 0,3.6977487 c 0,0.994967 0.517351,1.255629 0.971921,1.255629 0.433907,0 0.712053,-0.237616 0.99894,-0.627815 1.12053,-1.601324 2.310994,-3.501457 2.785431,-4.3255627 0.08662,-0.1478145 0.196291,-0.2598675 0.279735,-0.2598675 0.08424,0 0.13192,0.046887 0.13192,0.3242384 l 0,3.8725828 c 0,0.690596 0.213775,1.016424 0.753378,1.016424 0.497483,0 0.821722,-0.34808 1.018013,-0.758146 0.713642,-1.491655 1.772186,-3.460132 2.224371,-4.2349668 0.110463,-0.173245 0.217748,-0.3258278 0.285298,-0.3258278 0.08424,0 0.108079,0.1056954 0.108079,0.3886093 l 0,3.6747023 c 0,0.994967 0.514173,1.255629 0.967153,1.255629 0.609536,0 0.99894,-0.434702 1.385165,-0.929801 0.712848,-0.933775 1.753113,-2.591524 2.379338,-3.6556296 0.213775,0.3472846 0.454569,0.7589406 0.650861,1.2119206 -0.524503,0.62702 -1.037881,1.338278 -1.037881,2.09404 0,0.801059 0.555497,1.27947 1.143576,1.27947 0.992585,0 1.899335,-0.954437 1.899335,-2.270464 0,-0.517351 -0.1502,-1.059337 -0.3449,-1.576688 0.8853,-0.8670204 1.94543,-1.7101992 2.72345,-1.9041065 -0.36716,0.5181457 -0.66994,1.2540398 -0.66994,2.2021195 0,1.815894 1.03868,3.549139 3.04927,3.549139 1.94543,0 3.30358,-1.536954 3.30358,-3.680265 0,-0.622252 -0.0199,-0.70808 -0.0604,-0.9663577 0.44901,-0.1970861 0.8408,-0.4982781 1.14676,-0.7390728 0.25351,-0.194702 0.45218,-0.3035762 0.60079,-0.3035762 0.1955,0 0.28689,0.1517881 0.28689,0.4323179 l 0,4.2405298 c 0,0.690596 0.21298,1.016424 0.75338,1.016424 0.4951,0 0.84318,-0.34808 1.03867,-0.758146 0.70888,-1.491655 1.74835,-3.48 2.20053,-4.2349668 0.10808,-0.173245 0.19629,-0.3059602 0.26146,-0.3059602 0.0882,0 0.13033,0.06596 0.13033,0.3456953 l 0,3.3758937 c 0,0.949669 0.42834,1.577484 1.38199,1.577484 0.99735,0 1.49324,-0.954437 2.35947,-2.423841 0.0405,-0.08821 0.0612,-0.150994 0.0612,-0.213775 0,-0.194702 -0.17325,-0.305166 -0.3449,-0.305166 -0.19311,0 -0.30358,0.196292 -0.95046,0.90755 -0.12795,0.135099 -0.25987,0.322649 -0.49669,0.322649 -0.089,0 -0.1502,-0.104106 -0.1502,-0.236026 l 0,-3.7843713 c 0,-1.0164239 -0.45934,-1.4264901 -1.04265,-1.4264901 -0.47285,0 -0.85987,0.194702 -1.27232,0.8002649 -0.73669,1.0831788 -1.49086,2.6193375 -1.89854,3.3933775 -0.0469,0.0906 -0.10967,0.219338 -0.15576,0.219338 -0.0461,0 -0.0628,-0.06676 -0.0628,-0.219338 l 0,-2.7671523 c 0,-0.7978808 -0.21615,-1.4264901 -1.05933,-1.4264901 -0.88848,0 -1.33987,0.6063576 -1.98755,1.0593378 -0.41484,0.3059602 -0.7796,0.5197351 -1.06331,0.6492715 -0.42835,-1.1022517 -1.231,-1.6609272 -1.89775,-1.6442384 -0.67391,0.023046 -1.14517,0.4362914 -1.14517,1.1284768 0,0.7096689 0.43232,1.2039735 1.01086,1.424106 0.32504,0.1295367 0.62782,0.1541717 1.0657,0.1541717 0.12636,0 0.25192,0 0.34411,-0.02463 0.0421,0.215364 0.0199,0.522119 0.0199,0.75894 0,1.060927 -0.62861,2.117086 -1.79682,2.117086 -1.20953,0 -1.92,-1.167417 -1.92,-2.50649 0,-1.0172184 0.3004,-1.8588078 0.7955,-2.4405297 0.19708,-0.2177483 0.34967,-0.3496689 0.34967,-0.5491391 0,-0.1009271 -0.15259,-0.1263576 -0.28212,-0.1263576 -0.81775,0 -1.72848,0.3687417 -2.3555,0.6913907 -0.82252,0.4331126 -1.79523,1.1491391 -2.59232,1.8619868 C 99.926384,8.9647152 99.453536,8.2081589 99.212742,7.6224636 99.123735,7.3848477 99.064927,7.1090861 98.885324,7.1090861 c -0.149404,0 -0.215364,0.1509934 -0.321854,0.4490066 -0.390199,1.146755 -2.463576,4.5003973 -2.917351,4.9541723 -0.04371,0.06199 -0.108079,0.130331 -0.131126,0.130331 -0.04053,0 -0.06437,-0.02146 -0.06437,-0.153377 l 0,-3.7843713 c 0,-1.0164239 -0.407682,-1.4264901 -0.975099,-1.4264901 -0.476026,0 -0.88053,0.194702 -1.273907,0.8002649 -0.714437,1.0831788 -1.576689,2.6614575 -1.98755,3.4378805 -0.06358,0.13351 -0.127152,0.174835 -0.147814,0.174835 -0.02464,0 -0.04689,-0.08583 -0.04689,-0.219338 l 0,-2.7671523 c 0,-1.0164239 -0.407682,-1.4264901 -0.970331,-1.4264901 -0.476821,0 -0.933775,0.1772186 -1.297748,0.8002649 -0.910729,1.5369537 -2.421457,3.8932455 -2.704371,4.2794705 -0.03815,0.06676 -0.08424,0.110463 -0.130331,0.131126 -0.03815,0 -0.06358,-0.04212 -0.06358,-0.149404 l 0,-3.6349673 c 0,-1.0164239 -0.409272,-1.4264901 -0.97351,-1.4264901 -0.780398,0 -1.209537,0.7168212 -1.492451,1.1682119 -0.388609,0.6270199 -0.904371,1.4717881 -1.316821,2.2513905 -0.27894,0.521325 -0.517351,0.993378 -0.603973,0.993378 -0.04371,0 -0.04371,-0.196292 -0.04371,-0.562649 l 0,-2.8958943 c 1.363709,-1.5162914 2.203709,-3.3735099 2.203709,-5.4055629 0,-1.1698013 -0.517351,-1.8150994 -1.32,-1.8150994 -1.489272,0 -2.633643,2.3356292 -2.633643,5.1003974 l 0,2.2482119 C 78.978828,8.7938543 78.330352,9.005245 77.529292,9.1618013 77.12161,7.9538543 76.256179,7.3260397 75.568762,7.3427285 c -0.674702,0.023046 -1.148344,0.4362914 -1.148344,1.1284768 0,1.1443709 1.12053,1.6196027 2.117086,1.6196027 l 0.282914,0 c 0.03973,0.217748 0.03973,0.456159 0.03973,0.69298 0,1.060927 -0.624636,2.117086 -1.792848,2.117086 -1.211126,0 -1.920794,-1.167417 -1.920794,-2.50649 0,-1.0172184 0.301986,-1.8588078 0.795496,-2.4405297 0.193907,-0.2177483 0.34649,-0.4124503 0.34649,-0.5491391 0,-0.1009271 -0.152583,-0.1263576 -0.28053,-0.1263576 -0.822516,0 -2.636821,1.1070199 -4.800794,3.2686094 -0.189934,-1.7300663 -0.408477,-3.4180134 -0.408477,-5.0614571 0,-1.8365563 0.367152,-3.3965563 0.453775,-3.8463576 0.04291,-0.2789404 0.06676,-0.4545695 0.06676,-0.5817218 0,-0.17403977 -0.08821,-0.26304639 -0.321854,-0.26304639 -1.751524,0 -5.599471,2.79019869 -5.599471,6.96238409 0,1.7054305 0.367153,2.9189408 1.015629,3.9766888 -0.241589,-0.04212 -0.431523,-0.04212 -0.608741,-0.04212 -0.689007,0 -1.339868,0.171655 -1.743576,0.259867 l 0,-0.434702 c 0,-0.925827 -0.219338,-2.2029136 -0.609537,-2.6360262 -0.04609,-0.044503 -0.110463,-0.063576 -0.170861,-0.063576 -0.178013,0 -0.390993,0.083444 -0.627814,0.2145695 -0.262252,0.1303311 -0.521325,0.2614569 -0.521325,0.3456954 0,0.041324 0,0.085033 0.06517,0.1923178 0.152583,0.2217219 0.564238,0.6500665 0.712847,1.6688745 -0.736688,-0.735894 -1.575894,-1.062517 -2.674172,-1.062517 -1.299338,0 -1.690331,0.581722 -1.690331,1.169007 0,1.123708 1.491656,1.685563 3.375099,1.685563 0.344901,0 0.732716,-0.06517 1.119736,-0.153378 0,0.34649 0.04371,0.653245 0.04371,0.910729 0,0.367947 0.06278,0.650066 0.303576,0.650066 0.366358,0 0.584106,-0.738278 0.625431,-1.795232 0.669934,-0.17404 1.362914,-0.323444 1.948609,-0.323444 0.279735,0 0.629404,0.03894 0.971921,0.105696 z m -4.258014,-0.216159 c -0.363973,0.04291 -0.585695,0.04291 -0.971126,0.04291 -0.845562,0 -1.468609,-0.325828 -1.468609,-0.797086 0,-0.301987 0.149404,-0.477616 0.581722,-0.477616 0.69298,0 1.251656,0.477616 1.858013,1.231788 z"
                  inkscape:connector-curvature="0" />
              </g>
            </g>
          </g>
        </g>
      </svg>
      <hr class="login-hr">
      <div class="copyright">
        <img src="../../img/main-logos.png" alt="YONGMALOGIS - COPYRIGHT 2022 YONGMA LOGIS, ALL RIGHTS RESERVED">
      </div>
    </div>
    <div class="login-wrap">
      <div class="logo-row">
        <div class="logo-txt">
          <strong>OMS</strong>
          <span>Connected by sight<br>Johnson & Johnson Surgical Vision</span>
        </div>
      </div>
      <div class="login-form">
        <legend class="blind">로그인</legend>
        <div class="input-row">
          <input
            type="text"
            class="default-input"
            id="login-id"
            v-model="userId"
            required
            autocomplete="off"
          />
          <label for="login-id" class="default-label">ID</label>
          <div class="bar"></div>
        </div>
        <div class="input-row">
          <input
            type="password"
            class="default-input"
            id="login-password"
            maxlength="20"
            v-model="userPassword"
            v-on:keyup.enter="clickLogin"
            required
          />
          <label for="login-password" class="default-label">Password</label>
          <div class="bar"></div>
        </div>
        <div class="btn-row">
          <!--<router-link to="/main" class="button default default-btn">
            LOGIN
          </router-link>-->
          <button class="button default default-btn" @click="clickLogin()">
            LOGIN
          </button>
        </div>
        <div class="chk-row">
          <input type="checkbox" id="maintain-status" class="default-chk" v-model="checked" />
          <label for="maintain-status" class="chk-label">ID 저장하기</label>
          <!--<button type="button" class="pwd-find-btn" @click="findPassword()">비밀번호 찾기</button>-->
        </div>
      </div>
    </div>
    <div data-app class="person-info-modal">
      <v-dialog
        v-model="personalInform"
        persistent
        max-width="500px"
        id="person-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">개인정보 수집 및 이용에 관한 고지</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="desc-wrap">
                    <span style="display:block">■ 개인정보 처리에 관한 동의 안내</span>
                    <ol>
                      <li>1. 수집∙이용 목적: 본 사이트 회원 가입 및 이용 (제품 주문 및 주문 진행 현황 확인)</li>
                      <li>2. 수집하려는 개인정보의 항목: 성명, 휴대폰 번호</li>
                      <li>3. 개인정보의 <strong>보유 및 이용 기간</strong>: 탈퇴 요청시 까지</li>
                      <li>4. 귀하는 동의를 거부하실 수 있으나, 동의를 거부하시는 경우 본 사이트 회원 가입 및 이용이 어렵습니다.</li>
                    </ol>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="ui-col text-center"
                >
                  <v-checkbox color="primary" v-model="personalInformVal" label="위의 고지내용에 동의합니다.">
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-row class="btns">
            <v-col
              cols="12"
              md="12"
              class="ui-col text-center"
            >
              <v-btn
                color="blue darken-1"
                class="default-btn-style"
                text
                @click="userStateChk"
              >
                확인
              </v-btn>
              <v-btn
                color="blue darken-1"
                class="close-btn-style"
                style="margin-left:10px"
                text
                @click="personalInform = false"
              >
                취소
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="400px"
        id="user-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">비밀번호 찾기</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="ID*"
                    required
                    v-model="findId"
                    oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    label="Email"
                    required
                    v-model="findEmail"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="setFindPassword()"
              >
                임시비밀번호 발급
            </v-btn>
            </v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
            >
              닫기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="passwordDialog"
        persistent
        max-width="400px"
        id="password-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ userPopupTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="ID*"
                    required
                    disabled
                    v-model="userId"
                    oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="이전 Password"
                    required
                    maxlength="20"
                    v-model="prePassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="변경 Password"
                    required
                    v-model="nextPassword"
                    maxlength="20"
                    :rules="rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <v-text-field
                    type="password"
                    label="변경 Password 확인"
                    required
                    v-model="confirmPassword"
                    maxlength="20"
                    :rules="rulesCheck"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col 
                  cols="12"
                  md="12">
                  <span class="text-h6" style="color:rgba(255,0,0,.6)">숫자 + 문자 + 특수문자 포함 8~20자리로 설정해주세요.</span>
                  <span class="text-h6" style="color:rgba(255,0,0,.6)">사용 가능 특수 문자 : !@#$%^*+=-</span>
                </v-col>
              </v-row>
            </v-container>
            <!--<small>*indicates required field</small>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer class="password-edit">
              <v-btn
                class="default-btn-style save-btn"
                color="blue darken-1"
                text
                @click="setChangePassword()"
              >
                저장
            </v-btn>
            <v-btn
              class="close-btn-style close-btn"
              color="blue darken-1"
              text
              @click="passwordDialog = false"
            >
              닫기
            </v-btn>
          </v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div data-app>
      <v-dialog
        v-model="monthInform"
        persistent
        max-width="500px"
        id="month-info-modal"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">비밀번호 변경 안내</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="notice-wrap">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#0F4C81"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                    </div>
                    <div class="text">
                      <strong>고객님의 개인정보보호를 위해 <span>비밀번호</span>를 변경해 주세요.</strong>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <div class="notice-desc">
                    - 90일간 비밀번호를 변경하지 않고 사용중이신 분에게 비밀번호 변경에 대해 안내 드립니다.<br>
                    - 동일한 비밀번호를 장기간 사용하실 경우 개인정보 유출로 인한 피해 위험이 높으므로 비밀번호를 변경해주시기 바랍니다.
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="ui-col text-center"
                >
                  <v-btn
                    color="blue darken-1"
                    class="default-btn-style"
                    text
                    @click="passwordChangeNow"
                  >
                    지금 변경하기
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    class="close-btn-style"
                    style="margin-left:10px"
                    text
                    @click="passwordMonthMark"
                  >
                    한달간 표기 안함
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { PersonInformData } from '../personInform/PersonInform.js'
// let personInform = PersonInformData

export default {
  name: 'Login',
  data() {
    return {
      userId: '',
      userPassword: '',
      checked: false,
      dialog: false,
      findEmail: '',
      findId: '',
      passwordDialog: false,
      rules: [
        value => this.setPassRules(value) 
        /*value => !!value || '비밀번호를 입력해주세요.',
        value => (/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/.test(value) === true) || '숫자,영문자,특수문자 조합 8~20자리로 사용해야 합니다.',
        value => (/(?=.*[^a-zA-Z0-9!@#$%^*+=-])/.test(value) === false) || '사용할 수 없는 문자가 있습니다.'*/

      ],
      rulesCheck: [
        value => this.setCheckRules(value)
        /*value => !!value || '비밀번호 확인을 입력해주세요.',
        value => value === this.nextPassword || '패스워드가 일치하지 않습니다'*/
      ],
      mainUserName: '',
      mainUserId: '',
      prePassword: '',
      nextPassword: '',
      confirmPassword: '',
      passFlag: false,
      personalInform: false,
      personalInformVal: false,
      personalInformDesc: '',
      personalCompany: 'jnj',
      userFirstYn: '',
      userLastyn: '',
      userPrivateYn: '',
      userPopupTitle: '비밀번호 변경안내',
      monthInform: false,
      privateFirstAgree: 'N'
    }
  },
  methods: {
    clickLogin() {
      //이거로 접근
      if (this.userId === '') {
        this.$swal({
          title: 'ID를 입력해주세요!'
        })
        return
      }
      if (this.userPassword === '') {
        this.$swal({
          title: '비밀번호를 입력해주세요!'
        })
        return
      }
      if (this.checked) {
        localStorage.setItem('saveId', this.userId)
      } else {
        localStorage.clear()
      }
      this.$loading.show({delay:0})
      this.$store.dispatch('apiLoginData', {'userId': this.userId, 'userPwd': this.userPassword}).then(() => {
        this.mainUserId = this.userId
        // console.log('this.rtnLogin = ' + JSON.stringify(this.rtnLogin))
        if (this.rtnLogin.code !== 'FAIL') {
          //console.log(this.rtnLogin.loginInfo[0]);
          // 로그인 성공 시
          // userFirstYn: 첫번째 로그인 했을때 -> 비밀번호 변경 창
          if(this.rtnLogin.loginInfo[0].userFirstYn === 'Y') {
            this.userPopupTitle = '최초 비밀번호 변경'
            this.passwordDialog = true
            return
          }
          // userPrivateYn: 개인정보동의화면
          
          if(this.rtnLogin.loginInfo[0].userPrivateYn === 'N'){
            this.personalInform = true
            // this.personalInformDesc = JSON.stringify(personInform[0].text)
            return
          }

          // userLastyn: 3개월 지났을때 -> 비밀번호 변경, 1개월연장
          // console.log(this.rtnLogin.loginInfo[0])
          if(this.rtnLogin.loginInfo[0].userLastYn === 'Y') {
            this.userPopupTitle = '비밀번호 변경안내'
            this.monthInform = true
            return
          }
          
          sessionStorage.clear()
          sessionStorage.setItem('userInfo', JSON.stringify(this.rtnLogin.loginInfo))
          sessionStorage.setItem('realKey', this.rtnLogin.gridKey)
          if(this.privateFirstAgree == 'Y'){
            sessionStorage.setItem('firstYn', this.privateFirstAgree)
          }
          
          window.realGrid2Lic = this.rtnLogin.gridKey

          this.$router.push('/main')
        } else {
          this.$swal({
            title: this.rtnLogin.message
          })
        }
      }).catch((error) => {
        this.$swal({
          title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300);
      })
    },
    userStateChk(){
      if(this.personalInformVal === true) {
          this.$loading.show({delay:0})
          this.$store.dispatch('updateUser', {'userId': this.userId, 'changeType': 'privteAgree', 'userPrivateYn': 'Y'}).then(() => {
            this.personalInform = false
            this.privateFirstAgree = 'Y'
            this.clickLogin()
          }).catch((error) => {
            this.$swal({
              title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
            })
          }).finally(() => {
          setTimeout(() => {
            this.$loadingHide()
          }, 300);
        })
      } else {
        this.$swal({
          title: '개인정보 수집의 동의하셔야 이용가능합니다.'
        })
        return
      }
    },
    findPassword(){
      this.dialog = true
      this.findId = ''
      this.findEmail = ''
    },
    setFindPassword(){
      if (this.findId === '') {
        this.$swal({
          title: 'ID를 입력해주세요.'
        })
        return
      }

      if (this.findEmail === '') {
        this.$swal({
          title: '가입 시 입력한 Email을 입력해주세요.'
        })
        return
      }
      // var initPassword = this.$getInitPassword()
      // console.log(initPassword)
    },
    setPassRules(value) {
      this.passFlag = false
      if (value === '') {
        return '비밀번호를 입력해주세요.'
      }else if (/^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/.test(value) === false){
        return '숫자,영문자,특수문자 조합 8~20자리로 사용해야 합니다.'
      }else if (/(?=.*[^a-zA-Z0-9!@#$%^*+=-])/.test(value) === true) {
        return '사용할 수 없는 문자가 있습니다.'
      }else{
        this.passFlag = true
        return true
      }
    },
    setCheckRules(value){
      this.checkFlag = false
      if (value === '') {
        return '비밀번호 확인을 입력해주세요.'
      }else if(this.nextPassword === ''){
        return '변경 비밀번호를 입력해주세요'
      }else if (value !== this.nextPassword) {
        return '패스워드가 일치하지 않습니다'
      }else{
        this.checkFlag = true
        return true
      }
    },
    setChangePassword(){
      if(this.passFlag === false) {
        this.$swal({
          title: 'Password로 사용할 수 없습니다.\n다시 입력해 주세요.'
        })
        return
      }

      if (this.nextPassword !== this.confirmPassword) {
        this.$swal({
          title: '입력한 패스워드가 다릅니다'
        })
        return
      }
      this.$loading.show({delay:0})
      
      var obj = {userId: this.mainUserId, changeType: 'password', userPwd: this.prePassword, userNextPwd: this.confirmPassword}

      if (this.rtnLogin.loginInfo[0].userFirstYn === 'Y') {
        obj.userFirstYn = 'Y'
      }

      this.$store.dispatch('apiUserSelfPwTran', obj).then(() => {
        if(this.loginPwTran.code === 'SUCCESS') {
          this.passwordDialog = false
          this.userPassword = ''
          this.$swal({
            title: '비밀번호가 변경되었습니다.'
          })
          //this.clickLogin()
        } else if (this.loginPwTran.code === "CUR_PW_ERROR"){ // 기존 비밀번호가 안 맞을 때
          this.$swal({
            title: this.loginPwTran.message
          })
        }else {
          this.$swal({
            title: this.loginPwTran.message
          })
        }
      }).catch((error) => {
        this.$swal({
          title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300);
      })
    },
    passwordChangeNow(){
      this.monthInform = false
      this.passwordDialog = true
    },
    passwordMonthMark(){
      this.$loading.show({delay:0})
        this.$store.dispatch('updateUser', {'userId': this.userId, 'changeType': 'monthLater', 'userMonthYn': 'Y'}).then(() => {
        }).catch((error) => {
          this.$swal({
            title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
          })
        }).finally(() => {
        setTimeout(() => {
          this.monthInform = false
          this.$loadingHide()
          this.clickLogin()
        }, 300);
      })
    }
    
  },
  mounted() {
    var id = localStorage.getItem('saveId')
    // console.log('id = ' + id)
    if (id !== null) {
      this.userId = id
      this.checked = true
    }

    setTimeout(() => {
      this.$loadingHide()
    }, 300);
    // this.setFindPassword()
  },
  computed: {
    ...mapGetters({
      rtnLogin: 'getUserLogin',
      loginPwTran: 'getUserSelfPwTran'
    })
  },
}
</script>
